<template>

  <div class="dash-panel dash-panel--connections">
    <div class="dash-panel__header">
      <span class="dash-panel__icon-wrap">
        <i class="fas fa-users"></i>
      </span>
      <div class="dash-panel__title-group">
        <span class="dash-panel__title">Available to hold space right now</span>
      </div>
    </div>
    <div class="dash-panel__body dash-panel__body--connections">

      <div>
        <!-- Search -->
        <div class="row mb-3">
          <div class="col-md-5 col-12">
            <b-input-group size="sm">
              <b-form-input
                v-model="search"
                type="search"
                placeholder="Search by name, city, or country..."
              ></b-form-input>
            </b-input-group>
          </div>
        </div>

        <!-- Connection cards grid -->
        <div class="conn-grid position-relative" style="min-height: 130px;">
          <list :connections="availables" :hide-connect="true"></list>

          <div v-if="!loading && !availables.length" class="conn-empty dash-chart-empty">
            <div class="dash-chart-empty__icon"><i class="fas fa-users fa-2x"></i></div>
            <p class="dash-chart-empty__text">No Member found</p>
          </div>

          <div v-if="loading" class="position-absolute" style="top: 30px; right: 50%">
            <i class="fas fa-spinner fa-spin gold fa-2x"></i>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

import ProcessingList from "./ProcessingList.vue";
import axios from "@/axios";

export default {
  components: {List: ProcessingList},
  props: {
    title: {
      type: String,
      default: 'Available to hold space right now',
    },
    hideConnect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      search: '',
      availables: [],
      _searchTimer: null
    }
  },
  watch: {
    search(val) {
      clearTimeout(this._searchTimer);
      this._searchTimer = setTimeout(() => {
        this.getAvailables(val);
      }, 400);
    }
  },
  methods: {
    getAvailables(q) {
      this.loading = true;
      axios('connections/available', { params: { q } }).then(res => {
        this.availables = res.data || [];
      }).finally(() => {
        this.loading = false;
      });
    },
  },
  mounted() {
    this.getAvailables();
  }
}
</script>

<style scoped>

/* ── Panel shell ── */
.dash-panel {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.07);
  border: 1px solid rgba(214,182,116,0.18);
  border-bottom: none;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* ── Panel header bar ── */
.dash-panel__header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  background: transparent;
  border-bottom: 1px solid rgba(214,182,116,0.18);
}

.dash-panel__icon-wrap {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #d6b674 0%, #c4a55a 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 0.95rem;
  flex-shrink: 0;
}

.dash-panel__title-group {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.dash-panel__title {
  font-weight: 700;
  font-size: 1rem;
  color: #333;
  letter-spacing: 0.3px;
  line-height: 1.2;
}

@media (max-width: 576px) {
  .dash-panel__title {
    font-size: 0.9rem;
  }
}

/* ── Panel body ── */
.dash-panel__body {
  padding: 18px;
  flex: 1;
}

/* ── Meditation chart ── */
.dash-chart-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 240px;
  background: linear-gradient(135deg, rgba(214,182,116,0.07) 0%, rgba(196,165,90,0.09) 100%);
  border-radius: 12px;
  border: 1px dashed rgba(214,182,116,0.35);
}
.dash-chart-empty__icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid rgba(214,182,116,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d6b674;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(214,182,116,0.15);
}
.dash-chart-empty__text {
  color: #888;
  font-size: 0.88rem;
  margin: 0;
}

.dash-panel__body--connections {
  padding: 20px 24px;
  max-height: 430px;
  overflow-y: auto;
  overflow-x: hidden;
}

.dash-panel__body--connections::-webkit-scrollbar {
  width: 5px;
}
.dash-panel__body--connections::-webkit-scrollbar-track {
  background: rgba(214,182,116,0.08);
}
.dash-panel__body--connections::-webkit-scrollbar-thumb {
  background: rgba(214,182,116,0.5);
  border-radius: 4px;
}

.conn-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 160px;
}

/* ── Connection card grid ── */
.conn-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

</style>
